export default __webpack_public_path__ + "static/media/stats.947fb387.svg";